import { Component, ViewContainerRef, OnInit, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService, StorageService, CustomValidator } from '@shared/index';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  errors: any;
  invalidFormData: boolean;
  formSubmitted: boolean;
  authForm: FormGroup;
  formattedErrors: Array<string> = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder,
    public vcr: ViewContainerRef,
    private el: ElementRef,
    private storage: StorageService
  ) {
    this.authForm = this.fb.group({
      'username': ['', Validators.required],
      'password': ['', Validators.required],
      'grant_type': 'password',
    });
  }

  ngOnInit() {
    const target = this.el.nativeElement.querySelector('.form-control')
    if (target) {
      target.focus();
    }
  }

  submitForm() {
    this.invalidFormData = true;
    if (this.authForm.valid) {
      this.invalidFormData = false;
      const credentials = this.authForm.value;
      this.formSubmitted = true;
      this.authService
      .attemptAuth('', credentials)
      .subscribe(
        data => {
          this.authService.getNavigation().subscribe(response => {
            this.authService.buildNavigation((response['top']));
            if (response['top'] && response['top'][0] && response['top'][0]['slug']) {
              const mainRoute = response['top'][0]['slug'];
              let redirectRoute = mainRoute;
              if (response['top'][0]['children'] && response['top'][0]['children']['left'] && response['top'][0]['children']['left'][0]) {
                const leftMainRoute = response['top'][0]['children']['left'][0];
                let childRoute = response['top'][0]['children']['left'][0]['slug'];
                redirectRoute += '/' + childRoute;
                if (leftMainRoute['children'] && leftMainRoute['children']['left'] && leftMainRoute['children']['left'][0]) {
                  childRoute = childRoute + '/' + leftMainRoute['children']['left'][0]['slug'];
                  redirectRoute += '/' + leftMainRoute['children']['left'][0]['slug'];
                }
                this.router.navigateByUrl(redirectRoute);
                this.storage.store('defaultRoute', redirectRoute);
              } else {
                this.router.navigateByUrl(mainRoute);
                this.storage.store('defaultRoute', mainRoute);
              }
            } else {
              this.storage.store('defaultRoute', 'dashboard');
              this.router.navigateByUrl('/')
            }
          })
        },
        err => {
          this.errors = err;
          this.formatError(err);
          this.formSubmitted = false;
        }
      );
    }
  }

  formatError(errorList) {
    this.formattedErrors = [];
    const parent = this;
    if (typeof errorList === 'object') {
      Object.keys(errorList).map(function(objectKey, index) {
        const value = errorList[objectKey];
          if (typeof errorList[objectKey] === 'string') {
            parent.formattedErrors.push(value);
          } else {
            if (value.length > 0) {
              parent.formattedErrors.push(value[0]);
            }
          }
      });
    } else {
      this.formattedErrors.push(errorList);
    }
  }
}
